import { StoreOrder } from '../../models';
import { getOrderStatusView } from './orderStatus';

export function OrderStatusBadge({ order }: { order: StoreOrder }) {
  const { dotClass } = getOrderStatusView(order, false);
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-champagne-light border border-champagne-dark px-2.5 py-0.5 text-xs font-medium text-text-dark whitespace-nowrap">
      <span className={`w-1.5 h-1.5 rounded-full ${dotClass}`} aria-hidden="true" />
      {order.statusLabel}
    </span>
  );
}
